/* eslint-disable max-len */
import React, {
  useRef,
  useState,
  forwardRef,
  useImperativeHandle,
  useEffect,
} from 'react';

import {
  Row,
  Col,
  Input,
  Select,
  Radio,
  DatePicker,
} from 'antd';
import moment from 'moment-timezone';
import NumberFormat from 'react-number-format';

import {
  SpForm, SpError, SpTextMute, SpCaption,
} from 'components/DesignKit';

import SimpleReactValidator from 'simple-react-validator';

import {
  validators,
} from 'utils/validationMessages';

import { API_END_POINTS } from 'api';

import formatAmount from 'utils/formatAmount';

import { MESSAGES, COUNTRY_CODES, PHONE_LENGTH } from 'appconstants';

import KYCFileUpload from 'components/KycFileUpload';

const { Option } = Select;
const dateFormat = 'MMM DD, YYYY';


type Props = {
  businessTypes: Array<Object>,
  businessCategories: Array<Object>,
  statesInCountry: Array<Object>,
  country: string,
  isIndia: boolean,
  selectedAccount: Object,
  selectedBusinessType: Function,
  businessByDraft: Object,
}

const BusinessDetails = (props: Props, ref) => {
  const {
    businessTypes,
    businessCategories,
    statesInCountry,
    country,
    isIndia,
    selectedAccount,
    selectedBusinessType,
    businessByDraft,
  } = props;
  const BUSINESS_VALUES = ['PRIVATE_LIMITED', 'PUBLIC_LIMITED', 'NONPROFIT_ORGANIZATION'];

  const getCountryCode = () => {
    if (businessByDraft?.business?.businessPhoneNumber) {
      return businessByDraft?.business?.businessPhoneNumber.substring(0, 2) === '+1' ? '+1' : '+91';
    }
    return isIndia ? '+91' : '+1';
  };

  const [, forceUpdate] = useState();
  const [name, setName] = useState((businessByDraft && businessByDraft.business && businessByDraft.business.name) ? businessByDraft.business.name : null);
  const [businessType, setBusinessType] = useState((businessByDraft && businessByDraft.business && businessByDraft.business.type) ? businessByDraft.business.type : null);
  const [businessCategory, setBusinessCategory] = useState((businessByDraft && businessByDraft.business && businessByDraft.business.categoryId) ? businessByDraft.business.categoryId : '');
  const [businessUrl, setBusinessUrl] = useState((businessByDraft && businessByDraft.business && businessByDraft.business.url) ? businessByDraft.business.url : '');
  const [businessPan, setBusinessPan] = useState((businessByDraft && businessByDraft.business && businessByDraft.business.businessPan) ? businessByDraft.business.businessPan : '');
  const [cin, setCin] = useState((businessByDraft && businessByDraft.business && businessByDraft.business.cin) ? businessByDraft.business.cin : null);
  const [gst, setGst] = useState((businessByDraft && businessByDraft.business && businessByDraft.business.gst) ? businessByDraft.business.gst : null);
  const [tan, setTan] = useState((businessByDraft && businessByDraft.business && businessByDraft.business.tan) ? businessByDraft.business.tan : null);

  const [employerIdNumber, setEmployerIdNumber] = useState(businessByDraft && businessByDraft.business && businessByDraft.business.ein ? businessByDraft.business.ein : null);
  const [streetAddress, setStreetAddress] = useState(businessByDraft && businessByDraft.business && businessByDraft.business.address ? businessByDraft.business.address.street : null);
  const [zipCode, setZipCode] = useState(businessByDraft && businessByDraft.business && businessByDraft.business.address ? businessByDraft.business.address.postalCode : null);
  const [city, setCity] = useState(businessByDraft && businessByDraft.business && businessByDraft.business.address ? businessByDraft.business.address.city : null);
  const [state, setState] = useState(businessByDraft && businessByDraft.business && businessByDraft.business.address ? businessByDraft.business.address.state : null);
  const [statementDescriptor, setStatementDescriptor] = useState(businessByDraft && businessByDraft.business && businessByDraft.business.statementDescriptor ? businessByDraft.business.statementDescriptor : '');
  const [registrationProofUrl, setRegistrationProofUrl] = useState(businessByDraft && businessByDraft.business && businessByDraft.business.kycRegistrationProofUrl ? businessByDraft.business.kycRegistrationProofUrl : '');
  const [panUrl, setPanUrl] = useState(businessByDraft && businessByDraft.business && businessByDraft.business.kycCompanyPanUrl ? businessByDraft.business.kycCompanyPanUrl : '');
  const [zipTag, setZipTag] = useState('');
  const [accountType, setAccountType] = useState('PAYMENT_GATEWAY');
  const [annualTurnOver, setAnnualTurnOver] = useState((businessByDraft && businessByDraft.business && businessByDraft.business.annualTurnOver && (businessByDraft.business.annualTurnOver / 100).toFixed(2)) || '');
  const [annualCardVolume, setAnnualCardVolume] = useState((businessByDraft && businessByDraft.business && businessByDraft.business.annualCardVolume && (businessByDraft.business.annualCardVolume / 100).toFixed(2)) || '');
  const [annualUpiVolume, setAnnualUpiVolume] = useState((businessByDraft && businessByDraft.business && businessByDraft.business.annualUpiVolume && (businessByDraft.business.annualUpiVolume / 100).toFixed(2)) || '');
  const [frontUrl, setFrontUrl] = useState(businessByDraft && businessByDraft.business && businessByDraft.business.kycStoreFront ? businessByDraft.business.kycStoreFront : '');
  const [insideUrl, setInsideUrl] = useState(businessByDraft && businessByDraft.business && businessByDraft.business.kycStoreInside ? businessByDraft.business.kycStoreInside : '');
  const [businessAddressUrl, setBusinessAddressUrl] = useState(businessByDraft && businessByDraft.business && businessByDraft.business.currentAddressProofUrl ? businessByDraft.business.currentAddressProofUrl : '');
  const [boardResolutionUrl, setBoardResolutionUrl] = useState(businessByDraft && businessByDraft.business && businessByDraft.business.boardResolutionUrl ? businessByDraft.business.boardResolutionUrl : '');
  const [gstProofUrl, setGstProofUrl] = useState(businessByDraft && businessByDraft.business && businessByDraft.business.gstCertificateUrl ? businessByDraft.business.gstCertificateUrl : '');
  const [eightyTwelveUrl, setEightyTwelveUrl] = useState(businessByDraft && businessByDraft.business && businessByDraft.business.eightyGAndTwelveACertificate ? businessByDraft.business.eightyGAndTwelveACertificate : null);
  const [companyStartDate, setCompanyStartDate] = useState(businessByDraft && businessByDraft.business && businessByDraft.business.companyStartDate ? businessByDraft.business.companyStartDate : '2021-06-01');
  const [isTaxExemptOrganisation, setIsTaxExemptOrganisation] = useState(businessByDraft && businessByDraft.business && businessByDraft.business.isTaxExemptOrganisation ? businessByDraft.business.isTaxExemptOrganisation : '');
  const currencyType = selectedAccount && selectedAccount.currency;
  const gstRegex = /^([0]{1}[1-9]{1}|[1-2]{1}[0-9]{1}|[3]{1}[0-7]{1})([a-zA-Z]{5}[0-9]{4}[a-zA-Z]{1}[1-9a-zA-Z]{1}[zZ]{1}[0-9a-zA-Z]{1})+$/;
  const tanRegex = /^([a-zA-Z]){4}([0-9]){5}([a-zA-Z]){1}?$/;
  const cinRegex = /^([L|U]{1})([0-9]{5})([A-Za-z]{2})([0-9]{4})([A-Za-z]{3})([0-9]{6})$/;
  const panRegex = /^([a-zA-Z]){5}([0-9]){4}([a-zA-Z]){1}?$/;
  const einRegex = /^([07][1-7]|1[0-6]|2[0-7]|[35][0-9]|[468][0-8]|9[0-589])-?\d{7}$/;
  const llpRegex = /[a-zA-Z0-9]{7}/;
  const postalCodeRegex = country === 'India' ? /^[1-9][0-9]{5}$/ : country === 'Canada' ? /^[a-zA-Z0-9]{1,15}$/ : /^[0-9][0-9]{4}$/;
  const descriptorRegex = /[<>'"*]/;
  const businessNameRegex = /^[ ]*([a-zA-Z'-.]{1,}( [a-zA-z'-. ]{1,})?)$/;
  const ifNumber = /^[0-9]+$/;
  const [countryCode, setCountryCode] = useState('+1');
  const [phoneFormate, setPhoneFormate] = useState('');
  const [businessPhoneNumber, setBusinessPhoneNumber] = useState('');

  const dateIssued = moment.utc(businessByDraft?.business?.companyStartDate).tz(selectedAccount.timezone).format(dateFormat);

  const defaultDate = () => (businessByDraft?.business?.companyStartDate ? moment(dateIssued, dateFormat) : '');

  useEffect(() => {
    if ((selectedAccount && selectedAccount.country && selectedAccount.country.id) === 1) {
      setZipTag('Zip code');
    } else if ((selectedAccount && selectedAccount.country && selectedAccount.country.id) === 2) {
      setZipTag('Pin code');
    }
  }, []);

  useEffect(() => {
    if (businessByDraft?.business?.businessPhoneNumber) {
      const cntryCode = getCountryCode();
      if (businessByDraft?.business?.businessPhoneNumber.length === 12 && cntryCode === '+1') {
        setCountryCode('+1');
        setBusinessPhoneNumber(businessByDraft?.business?.businessPhoneNumber.slice(2));
        setPhoneFormate('(###) ###-####');
      } else if (businessByDraft?.business?.businessPhoneNumber.length === 13 && cntryCode === '+91') {
        setCountryCode('+91');
        setBusinessPhoneNumber(businessByDraft?.business?.businessPhoneNumber.slice(3));
        setPhoneFormate('##### #####');
      }
    }
  }, [businessByDraft]);

  const simpleValidator = useRef(new SimpleReactValidator({
    validators: {
      validUrl: {
        message: 'Business website must be valid',
        // eslint-disable-next-line max-len
        rule: val => (new RegExp('^(https?://)?(www\\.)?([-a-z0-9]{1,63}\\.)*?[a-z0-9][-a-z0-9]{0,61}[a-z0-9]\\.[a-z]{2,6}(/[-\\w@\\+\\.~#\\?&/=%]*)?$').exec(val) !== null),
      },
      cin: {
        message: MESSAGES.BUSINESS_DETAILS.CIN,
        rule: val => cinRegex.test(val),
      },
      llp: {
        message: MESSAGES.BUSINESS_DETAILS.LLP,
        rule: val => llpRegex.test(val),
      },
      tan: {
        message: MESSAGES.BUSINESS_DETAILS.TAN,
        rule: val => tanRegex.test(val),
      },
      gst: {
        message: MESSAGES.BUSINESS_DETAILS.GST,
        rule: val => gstRegex.test(val),
      },
      pan: {
        message: MESSAGES.BUSINESS_DETAILS.PAN,
        rule: val => panRegex.test(val),
      },
      EIN: {
        message: MESSAGES.BUSINESS_DETAILS.EIN,
        rule: val => einRegex.test(val),
      },
      postalcode: {
        message: validators.address.pincode,
        rule: val => (postalCodeRegex.test(val)),
      },
      descriptor: {
        message: 'Statement Descriptor min 5 and max 22 characters',
        // eslint-disable-next-line max-len
        rule: val => val && val.length >= 5 && val.length <= 22 && !descriptorRegex.test(val) && Boolean(val.charAt(0).match(/[a-zA-Z]/)) && Boolean(val.charAt(val.length - 1).match(/[a-zA-Z]/)),
      },
      phoneLength: {
        message: MESSAGES.ADD_USER.PHONE,
        rule: val => val.length >= PHONE_LENGTH.MIN && val.length <= PHONE_LENGTH.MAX,
      },
      isNumberField: {
        message: 'Enter number',
        rule: (val) => (ifNumber.test(val)),
      },
      isBusinessValid: {
        message: 'Business Name should be at least 4 characters long',
        rule: (val) => (val.length >= 4),
      },
      validname: {
        message: 'Please enter a valid Business Name',
        // eslint-disable-next-line no-useless-escape
        rule: val => /^[A-Za-z0-9][A-Za-z0-9\s\-.,'$@_]*[A-Za-z0-9\s\-.,'$@_]$/.test(val),
      },
      legalNameValidation: {
        message: "Business name must be alphanumeric and may include &, -, ., ', $, @, _, and spaces only.",
        rule: val => /^[A-Za-z0-9&,\s.\-'$@_]{1,50}$/.test(val),
      },
      validBusinessName: {
        message: 'Business Name cannot have special characters or numbers',
        rule: (val) => (businessNameRegex.test(val)),
      },
    },
  }));

  simpleValidator.current.purgeFields();

  const onCountryCodeChange = (value) => {
    if (value === '+1') {
      setPhoneFormate('(###) ###-####');
      setCountryCode(value);
    } else if (value === '+91') {
      setPhoneFormate('##### #####');
      setCountryCode(value);
    } else {
      setPhoneFormate('##########');
      setCountryCode(value);
    }
  };

  useEffect(() => {
    if (countryCode === '+1') {
      setPhoneFormate('(###) ###-####');
    } else if (countryCode === '+91') {
      setPhoneFormate('##### #####');
    }
  }, []);

  const onPhoneNumberChange = (e) => {
    const updatedPhone = e.currentTarget.value;
    setBusinessPhoneNumber(updatedPhone.replace(/[^0-9+]/g, ''));
  };

  useEffect(() => {
    if (accountType !== 'POS') {
      simpleValidator.current.purgeFields();
    }
  }, [accountType]);

  const updateGst = (e) => {
    if (e.currentTarget.value) {
      setGst(e.currentTarget.value.toUpperCase());
    } else if (!e.currentTarget.value) {
      setGst(null);
      simpleValidator.current.purgeFields();
    }
  };

  const updateTan = (e) => {
    if (e.currentTarget.value) {
      setTan(e.currentTarget.value.toUpperCase());
    } else if (!e.currentTarget.value) {
      setTan(null);
      simpleValidator.current.purgeFields();
    }
  };

  const bussinessTypeChange = (event) => {
    selectedBusinessType(event);
    setBusinessType(event);
    if (event === 'PROPRIETORSHIP') {
      simpleValidator.current.purgeFields();
    }
  };

  const onAccountChange = (e) => {
    setAccountType(e.target.value);
  };

  useImperativeHandle(ref, () => ({
    validate: () => {
      const formValid = simpleValidator.current.allValid();
      if (!formValid) {
        simpleValidator.current.showMessages();
        forceUpdate(1);
        return false;
      }
      return true;
    },
    getValues: () => ({
      name,
      businessType,
      businessCategory,
      businessUrl,
      companyStartDate,
      businessPhoneNumber,
      countryCode,
      isTaxExemptOrganisation,
      employerIdNumber: employerIdNumber || null,
      streetAddress,
      zipCode,
      city,
      state,
      statementDescriptor,
      registrationProofUrl,
      panUrl,
      businessPan,
      cin,
      gst,
      tan,
      accountType,
      annualTurnOver: annualTurnOver ? annualTurnOver.replace(/[^\d]/g, '') : '',
      annualCardVolume: annualCardVolume ? annualCardVolume.replace(/[^\d]/g, '') : '',
      annualUpiVolume: annualUpiVolume ? annualUpiVolume.replace(/[^\d]/g, '') : '',
      frontUrl,
      insideUrl,
      isLLP: businessType !== 'PROPRIETORSHIP' && !BUSINESS_VALUES.includes(businessType),
      currentAddressProofUrl: businessAddressUrl,
      boardResolutionUrl,
      gstCertificateUrl: gstProofUrl,
      eightyGAndTwelveACertificate: eightyTwelveUrl,
    }),
  }));

  return (
    <>
      <SpForm>
        <Row type="flex" justify="start" align="middle">
          <Col span={4}>
            <span>Business Name</span>
          </Col>
          <Col span={6}>
            <Input
              value={name}
              placeholder="Legal Business Name"
              onBlur={() => setName(name && name.trim())}
              onChange={e => setName(e.currentTarget.value)}
            />
            <SpError>
              {simpleValidator.current.message('Name', name, 'required|validname|legalNameValidation')}
            </SpError>
          </Col>
        </Row>

        <Row type="flex" justify="start" align="middle">
          <Col span={4}>
            <span>Business Type</span>
          </Col>
          <Col span={6}>
            <Select
              placeholder="Select Business Type"
              className="w-100"
              value={businessType}
              onChange={bussinessTypeChange}
            >
              { selectedAccount?.accountType && selectedAccount?.accountType === 'BUSINESS'
                ? businessTypes.filter((item) => item?.value !== 'INDIVIDUAL_OR_SOLE_PROPRIETORSHIP').map(business => (
                  <Option
                    key={1}
                    value={business.value}
                    className="text-capitalize"
                  >
                    {business.display}
                  </Option>
                ))
                : businessTypes.map(business => (
                  <Option
                    key={1}
                    value={business.value}
                    className="text-capitalize"
                  >
                    {business.display}
                  </Option>
                ))}
            </Select>
            <SpError>
              {simpleValidator.current.message('Business Type', businessType, 'required')}
            </SpError>
          </Col>
          <Col span={4} className="ml-4" align="left">
            <span>Business Category</span>
          </Col>
          <Col span={6} className="ml-2">
            <Select
              placeholder="Select Business Category"
              showSearch
              optionFilterProp="children"
              className="w-100"
              value={businessCategory}
              onChange={value => setBusinessCategory(value)}
            >
              {
                businessCategories.map(category => (
                  <Option
                    key={1}
                    value={category.id}
                    className="text-capitalize"
                  >
                    {category.name}
                  </Option>
                ))
              }
            </Select>
            <SpError>
              {simpleValidator.current.message('Business Category', businessCategory, 'required')}
            </SpError>
          </Col>
        </Row>

        <Row type="flex" justify="start" align="middle">
          <Col span={4}>
            <span>Business Website</span>
          </Col>
          <Col span={6}>
            <Input
              placeholder="Legal Business URL"
              value={businessUrl}
              onBlur={() => setBusinessUrl(businessUrl && businessUrl.trim())}
              onChange={e => setBusinessUrl(e.currentTarget.value && e.currentTarget.value.toLowerCase())}
            />
            <SpError>
              {simpleValidator.current.message('Business Url', businessUrl, 'required|validUrl')}
            </SpError>
          </Col>
        </Row>

        {!isIndia && (
          <Row type="flex" justify="start" align="middle">
            <Col span={4}>
              <span>Company Start Date</span>
            </Col>
            <Col span={6}>
              <DatePicker
                defaultValue={defaultDate()}
                allowClear={false}
                onChange={(date, dateString) => setCompanyStartDate(dateString)}
                disabledDate={current => current && current > moment().subtract(1, 'days')}
              />
              <SpError>
                {simpleValidator.current.message('Company Start Date', companyStartDate, 'required')}
              </SpError>
            </Col>
            <Col span={8} className="ml-4">
              <SpTextMute>
                Ensure it matches with provided EIN
              </SpTextMute>
            </Col>
          </Row>
        )}
        {
          isIndia ? (
            <>
              <Row type="flex" justify="start" align="middle">
                <Col span={4}>
                  <span>Business PAN</span>
                </Col>
                <Col span={6}>
                  <Input
                    placeholder="Business PAN"
                    value={businessPan}
                    onBlur={() => setBusinessPan(businessPan && businessPan.trim())}
                    onChange={e => setBusinessPan((e.currentTarget.value).toUpperCase())}
                  />
                  <SpError>
                    {simpleValidator.current.message('pan', businessPan, 'required|pan', { messages: { required: 'The PAN field is required.' } })}
                  </SpError>
                </Col>
                {
                  (businessType !== 'PROPRIETORSHIP') && (
                    <>
                      {
                        businessType === 'LIMITED_LIABILITY_PARTNERSHIP' ? (
                          <>
                            <Col span={4} className="ml-4" align="left">
                              <span>
                                LLP ID
                              </span>
                            </Col>
                            <Col span={6} className="ml-2">
                              <Input
                                value={cin}
                                placeholder="LLP ID"
                                onBlur={() => setCin(cin && cin.trim())}
                                onChange={e => setCin((e.currentTarget.value).toUpperCase())}
                              />
                              <SpError>
                                {simpleValidator.current.message('CIN', cin, 'required|llp',
                                  { messages: { required: 'The LLP ID field is required' } })}
                              </SpError>
                            </Col>
                          </>
                        ) : (
                          <>
                            <Col span={4} className="ml-4" align="left">
                              <span>
                                Company Identification Number (CIN)
                              </span>
                            </Col>
                            <Col span={6} className="ml-2">
                              <Input
                                value={cin}
                                placeholder="Company Identification Number"
                                onBlur={() => setCin(cin && cin.trim())}
                                onChange={e => setCin((e.currentTarget.value).toUpperCase())}
                              />
                              {
                                businessType === 'NONPROFIT_ORGANIZATION' ? (
                                  <SpError>
                                    {simpleValidator.current.message('CIN', cin, 'cin')}
                                  </SpError>
                                ) : (
                                  <SpError>
                                    {simpleValidator.current.message('CIN', cin, 'required|cin',
                                      { messages: { required: 'The CIN field is required' } })}
                                  </SpError>
                                )
                              }
                            </Col>
                            {
                              businessType === 'NONPROFIT_ORGANIZATION' ? (
                                <Col>
                                  <SpCaption className="pl-2">(Optional)</SpCaption>
                                </Col>
                              ) : null
                            }
                          </>
                        )
                      }
                    </>
                  )
                }
              </Row>
              <Row type="flex" justify="start" align="middle">
                <Col span={4}>
                  <span>GST Identification Number</span>
                </Col>
                <Col span={6}>
                  <Input
                    placeholder="GST Identification Number"
                    value={gst}
                    onBlur={() => setGst(gst && gst.trim())}
                    onChange={updateGst}
                  />
                  <SpError>
                    {gst ? simpleValidator.current.message('gst', gst, 'gst') : ''}
                  </SpError>
                </Col>
                <Col>
                  <SpCaption className="pl-4">(Optional)</SpCaption>
                </Col>
              </Row>
              <Row type="flex" justify="start" align="middle">
                <Col span={4}>
                  <span>Tax deduction account number (TAN)</span>
                </Col>
                <Col span={6}>
                  <Input
                    placeholder="TAN Number"
                    value={tan}
                    onBlur={() => setTan(tan && tan.trim())}
                    onChange={updateTan}
                  />
                  <SpError>
                    {tan ? simpleValidator.current.message('tan', tan, 'tan') : ''}
                  </SpError>
                </Col>
                <Col>
                  <SpCaption className="pl-4">(Optional)</SpCaption>
                </Col>
              </Row>
            </>
          ) : (
            <Row type="flex" justify="start" align="middle">
              <Col span={4}>
                <span>Employer Identification No.</span>
              </Col>
              <Col span={6}>
                <Input
                  placeholder="EIN of the company"
                  value={employerIdNumber}
                  onBlur={() => setEmployerIdNumber(employerIdNumber && employerIdNumber.trim())}
                  onChange={e => setEmployerIdNumber(e.currentTarget.value)}
                />
                {(businessType !== 'INDIVIDUAL_OR_SOLE_PROPRIETORSHIP') && (businessType !== 'LIMITED_LIABILITY_COMPANY')
                  ? (
                    <SpError>
                      {simpleValidator.current.message('Employer Id Number', employerIdNumber, 'required|EIN')}
                    </SpError>
                  ) : (
                    <SpError>
                      {simpleValidator.current.message('Employer Id Number', employerIdNumber, 'EIN')}
                    </SpError>
                  )}
              </Col>
              {(businessType === 'INDIVIDUAL_OR_SOLE_PROPRIETORSHIP') || (businessType === 'LIMITED_LIABILITY_COMPANY')
                ? (
                  <Col>
                    <SpCaption className="pl-4">(Optional)</SpCaption>
                  </Col>
                ) : null}
            </Row>
          )
        }

        {!isIndia && (
          <Row type="flex" justify="start" align="middle">
            <Col span={4}>
              <span>Business Phone Number</span>
            </Col>
            <Col span={6}>
              <div className="d-flex">
                <Select
                  style={{ width: '25%' }}
                  defaultValue={countryCode}
                  onChange={onCountryCodeChange}
                >
                  {COUNTRY_CODES.map((item) => (
                    <Option key={item.ID} value={item.PHONE_CODE}>
                      {item.PHONE_CODE}
                    </Option>
                  ))}
                </Select>
                <div style={{ width: '75%' }}>
                  <NumberFormat
                    className="InputnumFormate"
                    value={businessPhoneNumber}
                    format={phoneFormate}
                    mask="_"
                    allowEmptyFormatting
                    onChange={onPhoneNumberChange}
                  />
                  <SpError>
                    {simpleValidator.current.message('Phone', businessPhoneNumber, 'required|phoneLength')}
                  </SpError>
                </div>
              </div>
            </Col>
          </Row>
        )}
        <Row type="flex" justify="start" align="middle">
          <Col span={4}>
            <span>Street Address</span>
          </Col>
          <Col span={6}>
            <Input
              placeholder="Street address for business"
              value={streetAddress}
              onBlur={() => setStreetAddress(streetAddress && streetAddress.trim())}
              onChange={e => setStreetAddress(e.currentTarget.value)}
            />
            <SpError>
              {simpleValidator.current.message('Street Address', streetAddress, 'required')}
            </SpError>
          </Col>
        </Row>

        <Row type="flex" justify="start" align="middle">
          <Col span={4}>
            <span>{zipTag}</span>
          </Col>
          <Col span={4}>
            <Input
              placeholder={zipTag}
              value={zipCode}
              onBlur={() => setZipCode(zipCode && zipCode.trim())}
              onChange={e => setZipCode(e.currentTarget.value)}
            />
            <SpError>
              {simpleValidator.current.message('Area Code', zipCode, 'required|postalcode')}
            </SpError>
          </Col>

          <Col span={2} className="ml-4">
            <span>City</span>
          </Col>
          <Col span={4}>
            <Input
              placeholder="City"
              value={city}
              onBlur={() => setCity(city && city.trim())}
              onChange={e => setCity(e.currentTarget.value)}
            />
            <SpError>
              {simpleValidator.current.message('City', city, 'required')}
            </SpError>
          </Col>

          <Col span={2} className="ml-4">
            <span>State</span>
          </Col>
          <Col span={4}>
            <Select
              placeholder="Select State"
              showSearch
              optionFilterProp="children"
              className="w-100"
              value={state}
              onChange={value => setState(value)}
            >
              {
                statesInCountry.map(s => (
                  <Option
                    key={s.id}
                    value={s.id}
                    className="text-capitalize"
                  >
                    {s.name}
                  </Option>
                ))
              }
            </Select>
            <SpError>
              {simpleValidator.current.message('State', state, 'required')}
            </SpError>
          </Col>
        </Row>

        <Row type="flex" justify="start" align="middle">
          <Col span={4}>
            <span>Country</span>
          </Col>
          <Col span={4}>
            <Select value={country} style={{ width: '100%' }} disabled>
              <Option key={country} value={country}>{country}</Option>
            </Select>
          </Col>
        </Row>

        <Row type="flex" justify="start" align="middle">
          <Col span={4}>
            <span>Statement Descriptor</span>
          </Col>
          <Col span={6}>
            <Input
              placeholder="Statement Descriptor"
              value={statementDescriptor}
              onBlur={() => setStatementDescriptor(statementDescriptor && statementDescriptor.trim())}
              onChange={e => setStatementDescriptor(e.currentTarget.value)}
            />
            <SpError>
              {simpleValidator.current.message('Statement Descriptor', statementDescriptor, 'required|descriptor')}
            </SpError>
          </Col>

          <Col span={8} className="ml-4">
            <SpTextMute>
              This business name show up on your customer’s statements.
              Choose something they will recognize to help prevent disputes.
            </SpTextMute>
          </Col>
        </Row>

        {
          !isIndia && (
            <>
              <Row type="flex" justify="start" align="middle">
                <Col span={4}>
                  <span>Is Business Tax Exempted Organisation</span>
                </Col>
                <Col span={6}>
                  <Select
                    placeholder="Is Business Tax Exempted Organisation"
                    optionFilterProp="children"
                    className="w-100"
                    showSearch
                    value={isTaxExemptOrganisation}
                    onChange={(value) => {
                      setIsTaxExemptOrganisation(value);
                    }}
                  >
                    <Option key={1} value>Yes</Option>
                    <Option key={2} value={false}>No</Option>
                  </Select>
                </Col>
                <Col>
                  <SpCaption className="pl-4">(Optional)</SpCaption>
                </Col>
              </Row>
            </>
          )
        }

        {
          isIndia && (
            <>
              <Row type="flex" justify="start" align="middle">
                <Col span={4}>
                  <span>Account Type</span>
                </Col>
                <Col span={9}>
                  <Radio.Group onChange={onAccountChange} value={accountType}>
                    <Radio value="PAYMENT_GATEWAY">Online Payment Gateway</Radio>
                    <Radio value="POS">POS</Radio>
                  </Radio.Group>
                </Col>
              </Row>
              <Row type="flex" justify="start" align="middle">
                <Col span={4}>
                  <span>Estimated Annual Turnover</span>
                </Col>
                <Col span={6}>
                  <Input
                    value={annualTurnOver}
                    placeholder="Estimated Annual Turnover"
                    onChange={(e) => {
                      const regex = /^\d*\.?\d*$/;
                      const { value } = e.currentTarget;
                      if (regex.test(value) || value === '') {
                        setAnnualTurnOver(e.currentTarget.value);
                      } else if (!regex.test(value)) {
                        setAnnualTurnOver(0.00);
                      }
                    }}
                    onKeyPress={e => {
                      const keyCode = e.charCode || e.which;
                      if ((keyCode < 48 || keyCode > 57) && keyCode !== 46 && keyCode !== 44) {
                        e.preventDefault();
                      }
                    }}
                    onBlur={e => {
                      if (e.currentTarget.value) {
                        const value = formatAmount(e.currentTarget.value, currencyType);
                        setAnnualTurnOver(value);
                      }
                    }}
                  />
                </Col>
                <Col>
                  <SpCaption className="pl-4">(Optional)</SpCaption>
                </Col>
              </Row>
              <Row type="flex" justify="start" align="middle">
                <Col span={4}>
                  <span>Estimated Annual Card Volume</span>
                </Col>
                <Col span={6}>
                  <Input
                    value={annualCardVolume}
                    placeholder="Estimated Annual Card Volume"
                    onChange={(e) => {
                      const regex = /^\d*\.?\d*$/;
                      const { value } = e.currentTarget;
                      if (regex.test(value) || value === '') {
                        setAnnualCardVolume(e.currentTarget.value);
                      } else if (!regex.test(value)) {
                        setAnnualCardVolume(0.00);
                      }
                    }}
                    onKeyPress={e => {
                      const keyCode = e.charCode || e.which;
                      if ((keyCode < 48 || keyCode > 57) && keyCode !== 46 && keyCode !== 44) {
                        e.preventDefault();
                      }
                    }}
                    onBlur={e => {
                      if (e.currentTarget.value) {
                        const value = formatAmount(e.currentTarget.value, currencyType);
                        setAnnualCardVolume(value);
                      }
                    }}
                  />
                </Col>
                <Col>
                  <SpCaption className="pl-4">(Optional)</SpCaption>
                </Col>
              </Row>
              <Row type="flex" justify="start" align="middle">
                <Col span={4}>
                  <span>Estimated Annual UPI Volume</span>
                </Col>
                <Col span={6}>
                  <Input
                    value={annualUpiVolume}
                    placeholder="Estimated Annual UPI Volume"
                    onChange={(e) => {
                      const regex = /^\d*\.?\d*$/;
                      const { value } = e.currentTarget;
                      if (regex.test(value) || value === '') {
                        setAnnualUpiVolume(e.currentTarget.value);
                      } else if (!regex.test(value)) {
                        setAnnualUpiVolume(0.00);
                      }
                    }}
                    onKeyPress={e => {
                      const keyCode = e.charCode || e.which;
                      if ((keyCode < 48 || keyCode > 57) && keyCode !== 46 && keyCode !== 44) {
                        e.preventDefault();
                      }
                    }}
                    onBlur={e => {
                      if (e.currentTarget.value) {
                        const value = formatAmount(e.currentTarget.value, currencyType);
                        setAnnualUpiVolume(value);
                      }
                    }}
                  />
                </Col>
                <Col>
                  <SpCaption className="pl-4">(Optional)</SpCaption>
                </Col>
              </Row>
              {accountType === 'POS' && (
                <>
                  <Row type="flex" justify="start" align="middle">
                    <Col span={4}>
                      <span>Store Front Picture</span>
                    </Col>
                    <Col span={6}>
                      <KYCFileUpload
                        name="FRONT"
                        endPoint={API_END_POINTS.UPLOAD_STORE_FRONT}
                        url={frontUrl}
                        setUrl={value => setFrontUrl(value)}
                        type="Business"
                      />
                      <SpError>
                        {simpleValidator.current.message('Store Front Url', frontUrl, 'required')}
                      </SpError>
                    </Col>
                    <Col span={8} className="ml-4">
                      <SpTextMute>
                        Upload an Image with Store front details of business.  Self attested mandatory.
                      </SpTextMute>
                    </Col>
                  </Row>
                  <Row type="flex" justify="start" align="middle">
                    <Col span={4}>
                      <span>Store Inside Picture</span>
                    </Col>
                    <Col span={6}>
                      <KYCFileUpload
                        name="INSIDE"
                        endPoint={API_END_POINTS.UPLOAD_STORE_INSIDE}
                        url={insideUrl}
                        setUrl={value => setInsideUrl(value)}
                        type="Business"
                      />
                      <SpError>
                        {simpleValidator.current.message('Store Inside Url', insideUrl, 'required')}
                      </SpError>
                    </Col>
                    <Col span={8} className="ml-4">
                      <SpTextMute>
                        Upload an Image with Store inside details of business. Self attested mandatory.
                      </SpTextMute>
                    </Col>
                  </Row>
                </>
              )}
              <Row type="flex" justify="start" align="middle">
                <Col span={4}>
                  <span>Business Registration Proof</span>
                </Col>
                <Col span={6}>
                  <KYCFileUpload
                    name="Registration"
                    endPoint={API_END_POINTS.UPLOAD_REGISTRATION}
                    url={registrationProofUrl}
                    setUrl={value => setRegistrationProofUrl(value)}
                    type="Business"
                  />
                  <SpError>
                    {simpleValidator.current.message('Registration Proof Url', registrationProofUrl, 'required')}
                  </SpError>
                </Col>
                <Col span={8} className="ml-4">
                  {
                    businessType === 'PROPRIETORSHIP' ? (
                      <SpTextMute>
                        GST Certificate / Shop Establishment Act Certificate / Registration Certificate
                      </SpTextMute>
                    ) : (
                      <SpTextMute>
                        {
                          BUSINESS_VALUES.includes(businessType)
                            ? 'Upload an Image or pdf of Certification of Incorporation'
                            : 'Upload an Image or pdf of Partnership Deed'
                        }
                      </SpTextMute>
                    )
                  }
                </Col>
              </Row>
              <Row type="flex" justify="start" align="middle">
                <Col span={4}>
                  <span>Business PAN Proof</span>
                </Col>
                <Col span={6}>
                  <KYCFileUpload
                    name="PAN"
                    endPoint={API_END_POINTS.UPLOAD_PAN}
                    url={panUrl}
                    setUrl={value => setPanUrl(value)}
                    type="Business"
                  />
                  <SpError>
                    {simpleValidator.current.message('pan Url', panUrl, 'required',
                      { messages: { required: 'The PAN proof url field is required' } })}
                  </SpError>
                </Col>
                <Col span={8} className="ml-4">
                  <SpTextMute>
                    Upload an Image or pdf with PAN details of business. Self attested mandatory.
                  </SpTextMute>
                </Col>
              </Row>
              <Row type="flex" justify="start" align="middle">
                <Col span={4}>
                  <span>Current Address Proof</span>
                </Col>
                <Col span={6}>
                  <KYCFileUpload
                    name="Address"
                    endPoint={API_END_POINTS.UPLOAD_BUSINESS_ADDRESS}
                    url={businessAddressUrl}
                    keyType="BUSINESS_CURRENT_ADDRESS_PROOF"
                    setUrl={value => setBusinessAddressUrl(value)}
                    type="Business"
                  />
                  <SpError>
                    {simpleValidator.current.message('address Url', businessAddressUrl, 'required',
                      { messages: { required: 'The Address proof url field is required' } })}
                  </SpError>
                </Col>
                <Col span={8} className="ml-4">
                  {
                    businessType === 'PROPRIETORSHIP' ? (
                      <SpTextMute>
                        Address Proof:
                        Any Utility Bill (Electricity / Telephone / Water Bill / Gas bill / Municipal Tax (not more than 3 months old)
                        or Insurance policy or Aadhar card). Self attested mandatory.
                      </SpTextMute>
                    ) : businessType === 'LIMITED_LIABILITY_PARTNERSHIP' ? (
                      <SpTextMute>
                        Current address proof of the partnership firm (e.g Utility bills not more than 3 months old). Self attested mandatory.
                      </SpTextMute>
                    ) : (
                      <SpTextMute>
                        Company current Address proof (e.g Utility bills not more than 3 months old). Self attested mandatory.
                      </SpTextMute>
                    )
                  }
                </Col>
              </Row>
              <Row type="flex" justify="start" align="middle">
                <Col span={4}>
                  <span>Board Resolution</span>
                </Col>
                <Col span={6}>
                  <KYCFileUpload
                    name="Boardresolution"
                    endPoint={API_END_POINTS.UPLOAD_BOARD_RESOLUTION}
                    url={boardResolutionUrl}
                    keyType="BUSINESS_BOARD_RESOLUTION_PROOF"
                    setUrl={value => setBoardResolutionUrl(value)}
                    type="Business"
                  />
                  <SpError>
                    {simpleValidator.current.message('board resolution', boardResolutionUrl, 'required',
                      { messages: { required: 'The board resolution url field is required' } })}
                  </SpError>
                </Col>
                <Col span={8} className="ml-4">
                  {
                    businessType === 'PROPRIETORSHIP' ? (
                      <SpTextMute>
                        Bank statement of last 12 months or front copy of bank statement if the account is new.
                      </SpTextMute>
                    ) : businessType === 'LIMITED_LIABILITY_PARTNERSHIP' ? (
                      <SpTextMute>
                        Board Resolution (should be signed by atleast two partners. Should not be self-attested).
                      </SpTextMute>
                    ) : businessType === 'NONPROFIT_ORGANIZATION' ? (
                      <SpTextMute>
                        Board Resolution (should be signed by atleast two trustees. Should not be self-attested).
                      </SpTextMute>
                    ) : (
                      <SpTextMute>
                        Board Resolution (should be signed by atleast two directors or Company Secretary. Should not be self-attested).
                      </SpTextMute>
                    )
                  }
                </Col>
              </Row>
              <Row type="flex" justify="start" align="middle">
                <Col span={4}>
                  <span>GST Certificate</span>
                </Col>
                <Col span={6}>
                  <KYCFileUpload
                    name="GSTCertificate"
                    endPoint={API_END_POINTS.UPLOAD_GST_CERTIFICATE}
                    url={gstProofUrl}
                    keyType="BUSINESS_GST_CERTIFICATE"
                    setUrl={value => setGstProofUrl(value)}
                    type="Business"
                  />
                  <SpError>
                    {simpleValidator.current.message('gst Url', gstProofUrl, 'required',
                      { messages: { required: 'The GST certificate url field is required' } })}
                  </SpError>
                </Col>
                <Col span={8} className="ml-4">
                  <SpTextMute>
                    GST Certificate. Self attested mandatory.
                  </SpTextMute>
                </Col>
              </Row>
              {
                businessType === 'NONPROFIT_ORGANIZATION' && (
                  <Row type="flex" justify="start" align="middle">
                    <Col span={4}>
                      <span>80G and 12A Certficate</span>
                    </Col>
                    <Col span={6}>
                      <KYCFileUpload
                        name="80GCertificate"
                        endPoint={API_END_POINTS.UPLOAD_EIGHTY_TWELVE}
                        url={eightyTwelveUrl}
                        keyType="BUSINESS_EIGHTY_G_AND_TWELVE_A_CERTIFICATE"
                        setUrl={value => setEightyTwelveUrl(value)}
                        type="Business"
                      />
                      <SpError>
                        {simpleValidator.current.message('80g and 12a Url', eightyTwelveUrl, 'required',
                          { messages: { required: 'The 80G and 12A certificate url field is required' } })}
                      </SpError>
                    </Col>
                    <Col span={8} className="ml-4">
                      <SpTextMute>
                        80G certificate and 12A Certficate. Self attested mandatory.
                      </SpTextMute>
                    </Col>
                  </Row>
                )
              }
            </>
          )
        }
      </SpForm>
    </>
  );
};

// $FlowFixMe
export default forwardRef(BusinessDetails);
